// @flow
import React, { type Node } from 'react';
import { useTranslation } from 'react-i18next';

import CommonPage from 'app/common/templates/CommonPage';


type Props = {
  children: Node,
  location: {
    pathname: string,
  },
  params: {
    id: string,
    type: string,
  }
};

const EventsPage = ({ children }: Props) => {
  const { t } = useTranslation('events');

  return (
    <CommonPage header={t('header', 'События')}>
      {children}
    </CommonPage>
  );
};

export default EventsPage;
